export default [
    {
        path: '/admin/academic/level-skills',
        name: 'level-skill',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/level-skill/index.vue')
    }
]
